export default "__VITE_ASSET__DfYJk1V9__"